// extracted by mini-css-extract-plugin
export default {"__rows":"styles___rows__RTT9Z","__column":"styles___column__XIr+P"};